import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
/**
 * Zustand store for managing payment method selection with session storage persistence
 */
export const usePaymentStore = create()(persist((set) => ({
    /** Initially no payment method selected */
    selectedPaymentMethodId: null,
    /**
     * Sets the selected payment method ID
     * @param paymentMethodId - The payment method ID to store
     */
    setPaymentMethodId: (paymentMethodId) => {
        set({ selectedPaymentMethodId: paymentMethodId });
    },
    /**
     * Clears the selected payment method
     */
    clearPaymentMethod: () => {
        set({ selectedPaymentMethodId: null });
    },
}), {
    name: 'payment-storage',
    storage: createJSONStorage(() => sessionStorage),
}));
